module.exports = __webpack_public_path__ + "static/media/google.739cfa2e.svg";